import angular from 'angular';
import dashboardContainer from './dashboardContainer';
import scenes from './scenes';

export default angular
  .module('businessPlanningDashboard.scenes.dashboardContainer', [scenes])
  .component('dashboardContainer', dashboardContainer).name;
